<script lang="ts">
  import { fade } from 'svelte/transition';
  
  const features = [
    {
      title: 'Email & Browser Extension',
      description: 'Manage and qualify meeting requests directly from your inbox or browser. Instantly screen outreach emails and accept only the most relevant ones without leaving your workflow.',
      comingSoon: true
    },
    {
      title: 'AI Meeting  Note-taker',
      description: 'Get automatic meeting summaries, key takeaways, and action items right after each call. Stay focused on the conversation while AddMeetings captures the details for you.',
      comingSoon: true
    },
    {
      title: 'Meeting Feedback & Analytics',
      description: 'Collect insights after every meeting to measure quality, engagement, and outcomes. Turn every conversation into data that helps you improve your future meetings.',
      comingSoon: true
    }
  ];
  
  let hoveredFeature: number|null = null;
</script>

<section class="bg-[#070811] py-32">
  <div class="container mx-auto px-4">
    <h2 class="text-center text-4xl md:text-5xl lg:text-6xl font-bold mb-16">
      <span class="text-white">Coming</span>
      <span class="text-am-blue">Soon.</span>
    </h2>
    
    <div class="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto">
      {#each features as feature, i}
        <div role="presentation"
          class="group relative p-8 rounded-2xl bg-[#12131a] border border-transparent hover:border-am-black-45 transition-colors duration-300"
          on:mouseenter={() => hoveredFeature = i}
          on:mouseleave={() => hoveredFeature = null}
        >
          <div class="flex items-start justify-between gap-4">
            <div>
              <h3 class="text-white text-2xl font-semibold mb-4">
                {feature.title}
              </h3>
              <p class="text-[#8a8c94] leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  /* Ensure smooth transitions */
  * {
    -webkit-tap-highlight-color: transparent;
  }

  .group:hover::after {
    opacity: 1;
  }
</style>
